// src/services/csr.service.js
import axios from "axios"

export async function fetchCSR() {
  const res = await axios.get("/csr", {
    validateStatus: (s) => s === 200 || s === 204
  })

  // 204 = no CSR active → don't render
  if (res.status === 204) return null

  // 200 = payload
  return res.data || null
}
